/* mc-enhance.js - capa de movimiento (GSAP). Mejora progresiva: si algo falla, el contenido sigue visible. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    if (reduce || !window.gsap) return;
    var gsap = window.gsap;
    if (window.ScrollTrigger) gsap.registerPlugin(window.ScrollTrigger);

    var secciones = document.querySelectorAll('main > section, [data-reveal]');
    secciones.forEach(function (el, i) {
      if (el.hasAttribute('data-cx-hero')) return; /* el héroe tiene su propia entrada */
      gsap.from(el, {
        opacity: 0, y: 40, duration: 0.9, ease: 'power3.out',
        scrollTrigger: window.ScrollTrigger ? { trigger: el, start: 'top 86%', once: true } : undefined
      });
    });

    /* entrada del héroe */
    var hero = document.querySelector('[data-cx-hero]');
    if (hero) {
      var bits = hero.querySelectorAll('.cx-hero__giant, .cx-hero__tin, .cx-hero__text, .cx-hero__meta, .cx-hero__bottom');
      gsap.from(bits, { opacity: 0, y: 30, duration: 1, ease: 'power3.out', stagger: 0.09, delay: 0.1 });
    }

    /* parallax suave de la lata del héroe */
    var tin = document.querySelector('[data-cx-tin]');
    if (tin && window.ScrollTrigger) {
      gsap.to(tin, { yPercent: 12, ease: 'none', scrollTrigger: { trigger: hero || tin, start: 'top top', end: 'bottom top', scrub: true } });
    }

    /* botones magnéticos */
    document.querySelectorAll('.cx-btn').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        btn.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.16) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.2) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }
  function load(src, cb) { var s = document.createElement('script'); s.src = src; s.onload = cb; s.onerror = cb; document.head.appendChild(s); }
  load('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js', function () {
    load('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js', function () {
      if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
    });
  });
})();
